import { useRequiredContext } from "@redotech/react-util/context";
import { isAdvancedCheckoutFeaturesAvailable } from "@redotech/redo-conversion-core-common/conversion/features";
import { ConversionFeature } from "@redotech/redo-conversion-settings-common/checkout-optimization-settings";
import { useTranslation } from "@redotech/redo-i18n";
import CodeBrowserIcon from "@redotech/redo-icons/code-browser.svg";
import CodeBrowserFilledIcon from "@redotech/redo-icons/code-browser_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { memo } from "react";
import { LockableSecondaryNavItem } from "./lockable-secondary-nav-item";

export const WidgetsItems = memo(function WidgetsItems() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);

  const isAvailable = isAdvancedCheckoutFeaturesAvailable({
    hasShopifyPlus: !!team.shopifyIntegration?.hasShopifyPlus,
    planDisplayName: team.shopifyIntegration?.planDisplayName,
    teamId: team._id,
  });

  return (
    <LockableSecondaryNavItem
      buttonLocation={ScheduleDemoButtonLocation.NAV_WIDGETS}
      extraShouldHide={!isAvailable}
      feature={ConversionFeature.WIDGETS}
      FilledIcon={CodeBrowserFilledIcon}
      friendlyName={t("Widgets", {
        context:
          "checkout conversion navigation label for storefront checkout widgets",
      })}
      href={routes.getConversionSubRoute("widgets")}
      id="widgets"
      UnfilledIcon={CodeBrowserIcon}
    />
  );
});
